<template>
  <div class="policy-condition-editor">
    <div v-if="type === 'time'" class="lab-note">第 {{ refId || '—' }} 轮及以后触发</div>
    <template v-else>
      <div class="formula-condition-row"><span>{{ type === 'measure' ? '当前措施强度' : '所选指标的当前值' }}</span><select :value="operator" :disabled="disabled" aria-label="比较方式" @change="setOperator($event.target.value)"><option value=">">大于 &gt;</option><option value=">=">大于或等于 ≥</option><option value="==">等于 ＝</option><option value="!=">不等于 ≠</option><option value="<=">小于或等于 ≤</option><option value="<">小于 &lt;</option></select></div>
      <span class="lab-hint">比较值（可使用数值、参数或加减乘除组合）</span>
      <formula-editor ref="formula" :value="right" :context="context" scope="condition" :disabled="disabled" @input="setRight" />
    </template>
  </div>
</template>
<script>
import FormulaEditor from './FormulaEditor.vue'
export default {
  name: 'PolicyConditionEditor', components: { FormulaEditor },
  props: { value: String, type: String, refId: [String, Number], context: Object, disabled: Boolean },
  computed: {
    parts () { return String(this.value || '').replace(/≥/g, '>=').replace(/≤/g, '<=').match(/^(.+?)(>=|<=|==|!=|>|<)\s*(.+)$/) },
    operator () { return this.parts ? this.parts[2] : '>=' },
    right () { return this.parts ? this.parts[3] : '0' },
    prefix () { return this.type === 'measure' ? '强度' : String(this.refId || '') }
  },
  methods: {
    setOperator (operator) { this.$emit('input', this.prefix + operator + this.right) },
    setRight (value) { this.$emit('input', this.prefix + this.operator + value) },
    validate () { return this.type === 'time' ? Promise.resolve(true) : this.$refs.formula.validate() }
  }
}
</script>
